import i18next from 'i18next';

i18next.addResourceBundle('es', 'FormErrorMessage', {
  email: {
    invalid: 'El email ingresado no es valido.',
    repeated: 'El email ya ha sido ingresado.'
  }
});
